import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { connect } from 'react-redux';
import { fetchZones, createZone, copyZone } from '../actions/zones';
import { fetchManips } from '../actions/manips';
import { fetchInsectsRef } from '../actions/insectsRef';
import { fetchCapturesRef } from '../actions/capturesRef';
import { fetchOtherPestsRef } from '../actions/otherPestsRef';
import { fetchZoneChoices } from '../actions/zonesRef';
import { fetchZoneTemplates } from '../actions/zoneTemplatesRef';

import {
  getIsFetching as getIsFetchingZone,
  getSortedZones,
  getIsCreating as getIsCreatingZone,
  getIsCopying as getIsCopyingZone,
  getHasCreateError as hasCreateZoneError,
} from '../reducers/zones';
import { getZonesRef } from '../reducers/zonesRef';
import { getZoneTemplatesRef } from '../reducers/zoneTemplatesRef';
import { getIsFetching as getIsFetchingManips } from '../reducers/manips';
import SegmentLoader from 'common/components/SegmentLoader';
import ZoneList from './ZoneList';
import ZoneHeader from './ZoneHeader';

const mapStateToProps = state => ({
  isFetching: getIsFetchingZone(state) && getIsFetchingManips(state),
  isCreatingZone: getIsCreatingZone(state),
  isCopyingZone: getIsCopyingZone(state),
  hasCreateZoneError: hasCreateZoneError(state),
  zones: getSortedZones(state),
  zonesRef: getZonesRef(state),
  zoneTemplatesRef: getZoneTemplatesRef(state),
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchZones: () => dispatch(fetchZones(ownProps.intervention, ownProps.type)),
  fetchManips: () =>
    dispatch(fetchManips(ownProps.type, ownProps.intervention)),
  createZone: name =>
    dispatch(createZone(ownProps.intervention, ownProps.type, name, '')),
  copyZone: (zoneId, zoneTemplateId, fromTemplate) =>
    dispatch(
      copyZone(
        ownProps.intervention,
        ownProps.type,
        zoneId,
        zoneTemplateId,
        fromTemplate
      )
    ),
  fetchInsectsRef: () => dispatch(fetchInsectsRef()),
  fetchCapturesRef: () => dispatch(fetchCapturesRef()),
  fetchOtherPestsRef: () => dispatch(fetchOtherPestsRef()),
  fetchZonesRef: () => dispatch(fetchZoneChoices(ownProps.intervention)),
  fetchZoneTemplatesRef: () =>
    dispatch(fetchZoneTemplates(ownProps.intervention)),
});

class App extends Component {
  getChildContext() {
    return {
      intervention: this.props.intervention,
      type: this.props.type,
    };
  }

  componentDidMount() {
    // Loading zones and manips
    Promise.all([
      this.props.fetchZonesRef(),
      this.props.fetchZoneTemplatesRef(),
      this.props.fetchZones(),
      this.props.fetchManips(),
      this.props.fetchInsectsRef(),
      this.props.fetchCapturesRef(),
      this.props.fetchOtherPestsRef(),
    ]);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  render() {
    const {
      isFetching,
      zones,
      createZone,
      isCreatingZone,
      copyZone,
      isCopyingZone,
      disabled,
      zonesRef,
      zoneTemplatesRef,
      hasCreateZoneError,
      intervention,
      type,
    } = this.props;
    if (
      isFetching ||
      zonesRef === undefined ||
      zoneTemplatesRef === undefined
    ) {
      return <SegmentLoader />;
    }

    return (
      <div>
        <ZoneHeader
          onCreate={createZone}
          taskType={type}
          isCreating={isCreatingZone}
          onCopy={copyZone}
          isCopying={isCopyingZone}
          canAdd={!disabled}
          zonesRef={zonesRef}
          zoneTemplatesRef={zoneTemplatesRef}
          hasCreateZoneError={hasCreateZoneError}
        />
        <ZoneList
          intervention={intervention}
          zones={zones}
          disabled={disabled}
        />
      </div>
    );
  }
}

App.propTypes = {
  type: PropTypes.string.isRequired,
  intervention: PropTypes.string.isRequired,
  site: PropTypes.string.isRequired,
  siteCase: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isCreatingZone: PropTypes.bool.isRequired,
  fetchZones: PropTypes.func.isRequired,
  fetchZonesRef: PropTypes.func.isRequired,
  createZone: PropTypes.func.isRequired,
  fetchManips: PropTypes.func.isRequired,
  zones: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  copyZone: PropTypes.func.isRequired,
  isCopyingZone: PropTypes.bool.isRequired,
  zonesRef: PropTypes.array,
  zoneTemplatesRef: PropTypes.array,
  hasCreateZoneError: PropTypes.bool.isRequired,
  taskId: PropTypes.string.isRequired,
};

App.childContextTypes = {
  intervention: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/App.js